
import { useState, useRef, useCallback } from 'react';
import { AudioQualityMetrics } from './types';

export const useAudioQualityMonitor = () => {
  const [qualityMetrics, setQualityMetrics] = useState<AudioQualityMetrics | null>(null);
  const analyserRef = useRef<AnalyserNode | null>(null);

  const updateQualityMetrics = useCallback(() => {
    if (!analyserRef.current) return;

    const bufferLength = analyserRef.current.frequencyBinCount;
    const dataArray = new Uint8Array(bufferLength);

    analyserRef.current.getByteFrequencyData(dataArray);

    const averageSignal = dataArray.reduce((a, b) => a + b, 0) / bufferLength;
    const volumeLevel = (averageSignal / 255) * 100;
    const signalLevel = 20 * Math.log10(averageSignal / 255);

    const speechRatio = 0.7; // TODO: Implementar detecção de fala
    const noiseLevel = signalLevel - 10;
    const clarity = volumeLevel;
    const stability = Math.max(0, 100 - (volumeLevel > 10 ? Math.abs(volumeLevel - 50) : 50));
    const signalToNoise = Math.max(0, signalLevel - noiseLevel);

    setQualityMetrics({
      volumeLevel: Math.round(volumeLevel),
      noiseLevel: Math.round(noiseLevel),
      signalLevel: Math.round(signalLevel),
      speechRatio: Math.round(speechRatio * 100),
      clarity: Math.round(clarity),
      stability: Math.round(stability),
      signalToNoise: Math.round(signalToNoise)
    });
  }, []);

  const setAnalyser = useCallback((analyser: AnalyserNode) => {
    analyserRef.current = analyser;
  }, []);

  return {
    qualityMetrics,
    updateQualityMetrics,
    setAnalyser
  };
};
